import { Injectable, Output, EventEmitter } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RouteService {
  queryParameterMap = {};
  activeRoute = '';
  queryString = '';
  routeParts: string[] = [];

  @Output()
  routeChange: EventEmitter<any> = new EventEmitter();

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.reset();
        this.activeRoute = decodeURIComponent(event.urlAfterRedirects);
        const parts = this.activeRoute.split('?');
        if (parts.length > 1) {
          this.activeRoute = parts[0];
          this.queryString = parts[1];
        }
        this.routeParts = this.activeRoute.split('/');
        this.publishRouteChange();
      }
    });
  }

  publishRouteChange() {
    this.routeChange.emit({
      activeRoute: this.activeRoute,
      queryString: this.queryString,
      routeParts: this.routeParts,
      queryParameterMap: this.queryParameterMap
    });
  }

  reset() {
    this.queryParameterMap = {};
    this.activeRoute = '';
    this.queryString = '';
    this.routeParts = [];
  }

  setQueryParameterMap(queryParameterMap: {}) {
    this.queryParameterMap = queryParameterMap;
    this.publishRouteChange();
  }
}
